module.exports = __webpack_public_path__ + "static/media/smiling-emoji-svgrepo-com.be67f66a.svg";